export function diasParadoNaFila(entradaColunaEm: string | null | undefined): number | null {
  if (!entradaColunaEm) return null;
  return Math.max(0, Math.floor((Date.now() - new Date(entradaColunaEm).getTime()) / 86_400_000));
}
